export default function Sidebar() {
  // Sidebar is no longer used on desktop — navigation is in TopBar.
  // Kept as a no-op component so existing imports don't break.
  return null;
}
